import { ENDPOINT_SUBSCRIPTIONS } from '../config'
import type { SubscriptionDocument } from '@/lib/types/subscription'
import type { StartTrialRequest } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Start a 30-day trial with Team plan features
 */
export async function startTrial(
  request: StartTrialRequest,
): Promise<SubscriptionDocument> {
  const response = await AuthAxios.post<SubscriptionDocument>(
    `${ENDPOINT_SUBSCRIPTIONS}/start-trial`,
    request
  )
  return response.data
}
